function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFB000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.29 26.678a3.632 3.632 0 0 1-3.64 3.625 3.632 3.632 0 0 1-3.64-3.625M2 21.938h27.3M27.48 21.938h.91c-2.011 0-4.55-1.623-4.55-3.625v-8.157C23.84 5.652 20.173 2 15.65 2s-8.19 3.652-8.19 8.156v8.156a3.632 3.632 0 0 1-3.64 3.625"
}));

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.d50dc47b.svg";
export { ForwardRef as ReactComponent };